"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class ControlLegend extends _react.default.PureComponent {
  render() {
    const {
      text,
      id,
      aside,
      optional,
      themeLegend
    } = this.props;
    const legendClasses = `inline-block ${themeLegend}`;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("legend", {
      htmlFor: id,
      className: legendClasses
    }, text, " ", optional && /*#__PURE__*/_react.default.createElement("span", {
      className: "txt-normal"
    }, "(optional)")), aside && /*#__PURE__*/_react.default.createElement("span", {
      className: "inline-block ml12"
    }, aside));
  }

}

exports.default = ControlLegend;

_defineProperty(ControlLegend, "propTypes", {
  /** Label text for this control. */
  text: _propTypes.default.string.isRequired,

  /** Element id used to group additional form controls. */
  id: _propTypes.default.string.isRequired,

  /** Additional content inserted alongside the label element. */
  aside: _propTypes.default.node,

  /** If `true`, the text `(optional)` is appended to the label element. */
  optional: _propTypes.default.bool,

  /** Classes to apply to the legend element. */
  themeLegend: _propTypes.default.string
});

_defineProperty(ControlLegend, "defaultProps", {
  themeLegend: 'txt-s txt-bold mb6'
});